import { render, staticRenderFns } from "./OccupazioneBinari.vue?vue&type=template&id=772ff7e2&"
import script from "./OccupazioneBinari.vue?vue&type=script&lang=js&"
export * from "./OccupazioneBinari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports